import { render, staticRenderFns } from "./RedirectToApp.vue?vue&type=template&id=f96fb4e2&"
import script from "./RedirectToApp.vue?vue&type=script&lang=js&"
export * from "./RedirectToApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports